import { NgModule } from '@angular/core';
import { BgProcessesContainerRoutingModule } from './bg-processes-container-routing.module';

@NgModule({
    imports: [
        BgProcessesContainerRoutingModule
    ]
})
export class BgProcessesContainerModule { }
